/**
 * R1 - Sanity client configuration
 * R4 - Uses environment variables for secure credential management
 * 
 * Requires:
 *   VITE_SANITY_PROJECT_ID — Your Sanity project ID (from sanity.io/manage)
 *   VITE_SANITY_DATASET     — Dataset name (typically "production")
 */

import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';
import type { SanityImageRef } from './types';

// R1 - Validate required env vars at module load
const projectId = import.meta.env.VITE_SANITY_PROJECT_ID;
const dataset = import.meta.env.VITE_SANITY_DATASET || 'production';

if (!projectId) {
  console.warn(
    '[Sanity] VITE_SANITY_PROJECT_ID is missing. CMS data will not load.'
  );
}

export const sanityClient = createClient({
  projectId,
  dataset,
  apiVersion: '2024-01-01',
  // R1 - useCdn for fast, cached reads on the public frontend
  useCdn: true,
});

// ── Image URL Builder ──
const builder = imageUrlBuilder(sanityClient);

/**
 * R2 - Generates optimized image URLs with hotspot support
 * @param source - Sanity image reference object
 * @returns ImageUrlBuilder for chaining .width() .height() .url()
 */
export function urlFor(source: SanityImageRef) {
  return builder.image(source);
}
